import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface TOption {
  value: any
  text: string
}

@Component({
  selector: 't-option',
  templateUrl: './option.component.html',
})
export class OptionComponent {

  @Input()
  options: TOption[] = [
    {
      value: true,
      text: 'Oui'
    },
    {
      value: false,
      text: 'Non'
    }
  ];

  // Value model
  private selectedValue: any;

  @Input() 
  get value() {
    return this.selectedValue;
  }

  @Output() valueChange = new EventEmitter();

  set value(val) {
    this.selectedValue = val;
    this.valueChange.emit(val);
  }

  private _control: FormControl

  @Input()
  get control() {
    return this._control;
  }

  set control(val) {
    this._control = val;
    this.selectedValue = val.value;
  }

  select(option: TOption) {
    const value = option.value;

    if (this.control) {
      this.control.setValue(value)
      this.selectedValue = value;
    }
    else {
      this.value = value;
    }
  }
}
